import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';
import { PaymentMethodAddEditConfig } from '@amfam/billing/payment-method/util';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-choose-payment-method-modal',
  templateUrl: './choose-payment-method.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChoosePaymentMethodComponent implements OnInit {
  @Output() addCreditDebitEvent = new EventEmitter<void>();
  @Output() addCheckingAccountEvent = new EventEmitter<void>();
  isHsPolicy$: Observable<boolean>;
  paymentMethodAddEditConfig$: BehaviorSubject<PaymentMethodAddEditConfig> = new BehaviorSubject(
    null
  );
  constructor(
    private store: Store,
    private modalService: DsModalService
  ) {}
  ngOnInit(): void {
    this.isHsPolicy$ = this.store.select(BillAccountsSelectors.selectIsSelectedBillPolicyHomesite);
  }

  addCheckingAccount(): void {
    this.addCheckingAccountEvent.emit();
  }

  addCreditDebit(): void {
    this.addCreditDebitEvent.emit();
  }
}
